<div class="page-container">
  <p-card class="card-section">
    <ng-template pTemplate="header">
      <div class="p-3">
        <h2 class="m-0"><i class="pi pi-list mr-2"></i>Fuel Entries</h2>
        <p class="text-color-secondary mt-1 mb-0">Browse all fuel entries recorded in the system</p>
      </div>
    </ng-template>

    <!-- Filters -->
    <div class="formgrid grid align-items-end mb-3">
      <div class="field col-12 md:col-3">
        <label class="font-semibold">Filter Year</label>
        <p-dropdown
          [options]="yearOptions"
          [(ngModel)]="filterYear"
          optionLabel="label"
          optionValue="value"
          [showClear]="true"
          placeholder="All years"
          styleClass="w-full"
          (onChange)="onFilterChange()">
        </p-dropdown>
      </div>
      <div class="field col-12 md:col-3">
        <label class="font-semibold">Filter Month</label>
        <p-dropdown
          [options]="monthOptions"
          [(ngModel)]="filterMonth"
          optionLabel="label"
          optionValue="value"
          [showClear]="true"
          placeholder="All months"
          styleClass="w-full"
          (onChange)="onFilterChange()">
        </p-dropdown>
      </div>
      <div class="field col-12 md:col-2">
        <button
          type="button"
          class="p-button p-button-secondary p-button-outlined"
          (click)="loadEntries()">
          <i class="pi pi-refresh mr-2"></i>Refresh
        </button>
      </div>
      <div class="field col-12 md:col-4 flex align-items-end justify-content-end">
        <span class="text-color-secondary text-sm">
          <i class="pi pi-info-circle mr-1"></i>
          {{ entries.length }} {{ entries.length === 1 ? 'entry' : 'entries' }} loaded
        </span>
      </div>
    </div>

    <!-- Loading bar -->
    <p-progressBar *ngIf="isLoading" mode="indeterminate" style="height: 4px"></p-progressBar>

    <!-- Table -->
    <div #tableAnchor></div>
    <p-table
      *ngIf="!isLoading"
      [value]="entries"
      [scrollable]="true"
      [scrollHeight]="tableHeight"
      [virtualScroll]="true"
      [virtualScrollItemSize]="46"
      styleClass="p-datatable-gridlines p-datatable-sm"
      [rowHover]="true"
      sortField="invoice_date"
      [sortOrder]="-1">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="invoice_date" style="min-width: 140px">
            Invoice Date <p-sortIcon field="invoice_date"></p-sortIcon>
          </th>
          <th pSortableColumn="truck_number" style="min-width: 130px">
            Truck # <p-sortIcon field="truck_number"></p-sortIcon>
          </th>
          <th pSortableColumn="quantity" style="min-width: 120px">
            Gallons <p-sortIcon field="quantity"></p-sortIcon>
          </th>
          <th pSortableColumn="vender" style="min-width: 160px">
            Vendor <p-sortIcon field="vender"></p-sortIcon>
          </th>
          <th style="min-width: 180px">City / State</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-entry>
        <tr>
          <td>{{ entry.invoice_date | date: 'MM/dd/yyyy' }}</td>
          <td>{{ entry.truck_number }}</td>
          <td>{{ entry.quantity | number: '1.3-3' }}</td>
          <td>{{ entry.vender }}</td>
          <td>{{ entry.city }}<span *ngIf="entry.city && entry.state">, </span>{{ entry.state }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center p-4 text-color-secondary">
            <i class="pi pi-inbox mr-2"></i>No fuel entries found for the selected filters.
          </td>
        </tr>
      </ng-template>
    </p-table>

  </p-card>
</div>
